import type { PlanId, PlanConfig } from './types';

/**
 * Visual / branding configuration per plan.
 * Gradients and colours are sourced from Figma — they are FE concerns and
 * will not be returned by the backend.
 */
export const PLAN_CONFIGS: Record<PlanId, PlanConfig> = {
  basic: {
    gradient: 'linear-gradient(209deg, rgb(248,249,249) 0.9%, rgb(223,226,228) 100.9%)',
    borderColor: null,
    borderGradient: 'linear-gradient(to bottom, #FFFFFF, #D1D3D7)',
    textColor: '#384553',
  },
  identity: {
    gradient: 'linear-gradient(29deg, rgb(119,18,123) 0.9%, rgb(193,24,139) 100.9%)',
    borderColor: null,
    borderGradient: 'linear-gradient(to bottom, #E539B0, #600C55)',
    textColor: '#ffffff',
  },
  credit_expert: {
    gradient: 'linear-gradient(29deg, rgb(30,14,52) 0.9%, rgb(44,90,189) 100.9%)',
    borderColor: null,
    borderGradient: 'linear-gradient(to bottom, #4C6BC9, #031E57)',
    textColor: '#ffffff',
  },
};
